import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { EmailVerificationAlert } from "@/components/auth/EmailVerificationAlert";
import { LoadingSpinner } from "@/components/auth/LoadingSpinner";
import { useAuthFlow } from "@/hooks/useAuthFlow";
import LinkPilotFavicon from '@/assets/linkpilot-favicon.png';

const AuthPage = () => {
  const { error, isLoading, isVerifying } = useAuthFlow();

  if (isLoading || isVerifying) {
    return <LoadingSpinner isVerifying={isVerifying} />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 space-y-6 bg-card rounded-lg border border-border shadow-xl">
        <div className="flex flex-col items-center space-y-4">
          <img 
            src={LinkPilotFavicon}
            alt="LinkPilot Logo"
            className="w-16 object-contain h-16"
          />
          <h1 className="text-2xl font-bold text-center text-foreground">Welcome to LinkPilot</h1>
        </div>
        
        <EmailVerificationAlert error={error} isVerifying={isVerifying} />

        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: 'hsl(var(--primary))',
                  brandAccent: 'hsl(var(--primary))',
                  brandButtonText: 'hsl(var(--primary-foreground))',
                  defaultButtonBackground: 'hsl(var(--secondary))',
                  defaultButtonBackgroundHover: 'hsl(var(--secondary))',
                  defaultButtonBorder: 'hsl(var(--border))',
                  defaultButtonText: 'hsl(var(--secondary-foreground))',
                  dividerBackground: 'hsl(var(--border))',
                  inputBackground: 'hsl(var(--background))',
                  inputBorder: 'hsl(var(--border))',
                  inputBorderHover: 'hsl(var(--border))',
                  inputBorderFocus: 'hsl(var(--ring))',
                  inputText: 'hsl(var(--foreground))',
                  inputLabelText: 'hsl(var(--muted-foreground))',
                  inputPlaceholder: 'hsl(var(--muted-foreground))',
                },
                borderWidths: {
                  buttonBorderWidth: '1px',
                  inputBorderWidth: '1px',
                },
                radii: {
                  borderRadiusButton: 'var(--radius)',
                  buttonBorderRadius: 'var(--radius)',
                  inputBorderRadius: 'var(--radius)',
                },
              },
            },
            className: {
              container: 'w-full',
              button: 'w-full px-4 py-2 rounded-md text-sm font-raleway',
              label: 'text-sm font-medium',
              input: 'w-full px-3 py-2 rounded-md',
              divider: 'my-4',
            },
          }}
          providers={[]}
        />
      </div>
    </div>
  );
};

export default AuthPage;